import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'

// Platform roles that can access the platform management system
const PLATFORM_ROLES = ['super_admin', 'platform_admin', 'platform_support']

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, token, user, clearAuth } = useAuthStore()
  const location = useLocation()

  // Check both store state and localStorage for token
  const hasToken = isAuthenticated || token || localStorage.getItem('token')

  if (!hasToken) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check if user is NOT a platform user (should not access platform system)
  if (user && !PLATFORM_ROLES.includes(user.role)) {
    // Clear auth and redirect to login
    clearAuth()
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
